import { BaseService } from "./BaseService";
import { FunctionGroup, MeasuresType } from "../types/app.enums";
import { Measures } from "../types/app.interfaces";

export class MinAndMaxDateService extends BaseService {
  burgissCalcFundingMaxDate(
    investId: any[][],
    idType: any,
    beginDate: any,
    endDate?: any,
    selectionSetId?: any,
    filter?: any
  ) {
    if (idType == "p") {
      const objRequest = this.createPayload(
        [],
        idType,
        beginDate,
        endDate,
        selectionSetId,
        filter,
        MeasuresType.FundingMaxDate,
        investId,
        []
      );
      return super._pushOperation(
        "BurgissCalcFundingMaxDate",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Minandmaxdate
      );
    }
    if (idType == "i") {
      const objRequest = this.createPayload(
        investId,
        idType,
        beginDate,
        endDate,
        selectionSetId,
        filter,
        MeasuresType.FundingMaxDate,
        [],
        []
      );
      return super._pushOperation(
        "BurgissCalcFundingMaxDate",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Minandmaxdate
      );
    }
    if (idType == "a") {
      const objRequest = this.createPayload(
        [],
        idType,
        beginDate,
        endDate,
        selectionSetId,
        filter,
        MeasuresType.FundingMaxDate,
        [],
        investId
      );
      return super._pushOperation(
        "BurgissCalcFundingMaxDate",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Minandmaxdate
      );
    }
    return null;
  }

  burgissCalcFundingMinDate(
    investId: any[][],
    idType: any,
    beginDate: any,
    endDate?: any,
    selectionSetId?: any,
    filter?: any
  ) {
    if (idType == "p") {
      const objRequest = this.createPayload(
        [],
        idType,
        beginDate,
        endDate,
        selectionSetId,
        filter,
        MeasuresType.FundingMinDate,
        investId,
        []
      );
      return super._pushOperation(
        "BurgissCalcFundingMinDate",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Minandmaxdate
      );
    }
    if (idType == "i") {
      const objRequest = this.createPayload(
        investId,
        idType,
        beginDate,
        endDate,
        selectionSetId,
        filter,
        MeasuresType.FundingMinDate,
        [],
        []
      );
      return super._pushOperation(
        "BurgissCalcFundingMinDate",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Minandmaxdate
      );
    }
    if (idType == "a") {
      const objRequest = this.createPayload(
        [],
        idType,
        beginDate,
        endDate,
        selectionSetId,
        filter,
        MeasuresType.FundingMinDate,
        [],
        investId
      );
      return super._pushOperation(
        "BurgissCalcFundingMinDate",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Minandmaxdate
      );
    }
    return null;
  }

  burgissCalcCashMaxDate(
    investId: any[][],
    idType: any,
    beginDate: any,
    endDate?: any,
    selectionSetId?: any,
    filter?: any
  ) {
    if (idType == "p") {
      const objRequest = this.createPayload(
        [],
        idType,
        beginDate,
        endDate,
        selectionSetId,
        filter,
        MeasuresType.CashMaxDate,
        investId,
        []
      );
      return super._pushOperation(
        "BurgissCalcCashMaxDate",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Minandmaxdate
      );
    }
    if (idType == "i") {
      const objRequest = this.createPayload(
        investId,
        idType,
        beginDate,
        endDate,
        selectionSetId,
        filter,
        MeasuresType.CashMaxDate,
        [],
        []
      );
      return super._pushOperation(
        "BurgissCalcCashMaxDate",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Minandmaxdate
      );
    }
    if (idType == "a") {
      const objRequest = this.createPayload(
        [],
        idType,
        beginDate,
        endDate,
        selectionSetId,
        filter,
        MeasuresType.CashMaxDate,
        [],
        investId
      );
      return super._pushOperation(
        "BurgissCalcCashMaxDate",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Minandmaxdate
      );
    }
    return null;
  }
  burgissCalcCashMinDate(
    investId: any[][],
    idType: any,
    beginDate: any,
    endDate?: any,
    selectionSetId?: any,
    filter?: any
  ) {
    if (idType == "p") {
      const objRequest = this.createPayload(
        [],
        idType,
        beginDate,
        endDate,
        selectionSetId,
        filter,
        MeasuresType.CashMinDate,
        investId,
        []
      );
      return super._pushOperation(
        "BurgissCalcCashMinDate",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Minandmaxdate
      );
    }
    if (idType == "i") {
      const objRequest = this.createPayload(
        investId,
        idType,
        beginDate,
        endDate,
        selectionSetId,
        filter,
        MeasuresType.CashMinDate,
        [],
        []
      );
      return super._pushOperation(
        "BurgissCalcCashMinDate",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Minandmaxdate
      );
    }
    if (idType == "a") {
      const objRequest = this.createPayload(
        [],
        idType,
        beginDate,
        endDate,
        selectionSetId,
        filter,
        MeasuresType.CashMinDate,
        [],
        investId
      );
      return super._pushOperation(
        "BurgissCalcCashMinDate",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Minandmaxdate
      );
    }
    return null;
  }
  burgissCalcFeesMaxDate(
    investId: any[][],
    idType: any,
    beginDate: any,
    endDate?: any,
    selectionSetId?: any,
    filter?: any
  ) {
    if (idType == "p") {
      const objRequest = this.createPayload(
        [],
        idType,
        beginDate,
        endDate,
        selectionSetId,
        filter,
        MeasuresType.FeesMaxDate,
        investId,
        []
      );
      return super._pushOperation(
        "BurgissCalcFeesMaxDate",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Minandmaxdate
      );
    }
    if (idType == "i") {
      const objRequest = this.createPayload(
        investId,
        idType,
        beginDate,
        endDate,
        selectionSetId,
        filter,
        MeasuresType.FeesMaxDate,
        [],
        []
      );
      return super._pushOperation(
        "BurgissCalcFeesMaxDate",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Minandmaxdate
      );
    }
    if (idType == "a") {
      const objRequest = this.createPayload(
        [],
        idType,
        beginDate,
        endDate,
        selectionSetId,
        filter,
        MeasuresType.FeesMaxDate,
        [],
        investId
      );
      return super._pushOperation(
        "BurgissCalcFeesMaxDate",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Minandmaxdate
      );
    }
    return null;
  }

  burgissCalcFeesMinDate(
    investId: any[][],
    idType: any,
    beginDate: any,
    endDate?: any,
    selectionSetId?: any,
    filter?: any
  ) {
    if (idType == "p") {
      const objRequest = this.createPayload(
        [],
        idType,
        beginDate,
        endDate,
        selectionSetId,
        filter,
        MeasuresType.FeesMinDate,
        investId,
        []
      );
      return super._pushOperation(
        "BurgissCalcFeesMinDate",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Minandmaxdate
      );
    }
    if (idType == "i") {
      const objRequest = this.createPayload(
        investId,
        idType,
        beginDate,
        endDate,
        selectionSetId,
        filter,
        MeasuresType.FeesMinDate,
        [],
        []
      );
      return super._pushOperation(
        "BurgissCalcFeesMinDate",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Minandmaxdate
      );
    }
    if (idType == "a") {
      const objRequest = this.createPayload(
        [],
        idType,
        beginDate,
        endDate,
        selectionSetId,
        filter,
        MeasuresType.FeesMinDate,
        [],
        investId
      );
      return super._pushOperation(
        "BurgissCalcFeesMinDate",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Minandmaxdate
      );
    }
    return null;
  }
  burgissCalcValuationMaxDate(
    investId: any[][],
    idType: any,
    beginDate: any,
    endDate?: any,
    selectionSetId?: any,
    filter?: any
  ) {
    if (idType == "p") {
      const objRequest = this.createPayload(
        [],
        idType,
        beginDate,
        endDate,
        selectionSetId,
        filter,
        MeasuresType.ValuationMaxDate,
        investId,
        []
      );
      return super._pushOperation(
        "BurgissCalcValuationMaxDate",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Minandmaxdate
      );
    }
    if (idType == "i") {
      const objRequest = this.createPayload(
        investId,
        idType,
        beginDate,
        endDate,
        selectionSetId,
        filter,
        MeasuresType.ValuationMaxDate,
        [],
        []
      );
      return super._pushOperation(
        "BurgissCalcValuationMaxDate",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Minandmaxdate
      );
    }
    if (idType == "a") {
      const objRequest = this.createPayload(
        [],
        idType,
        beginDate,
        endDate,
        selectionSetId,
        filter,
        MeasuresType.ValuationMaxDate,
        [],
        investId
      );
      return super._pushOperation(
        "BurgissCalcValuationMaxDate",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Minandmaxdate
      );
    }
    return null;
  }
  burgissCalcValuationMinDate(
    investId: any[][],
    idType: any,
    beginDate: any,
    endDate?: any,
    selectionSetId?: any,
    filter?: any
  ) {
    if (idType == "p") {
      const objRequest = this.createPayload(
        [],
        idType,
        beginDate,
        endDate,
        selectionSetId,
        filter,
        MeasuresType.ValuationMinDate,
        investId,
        []
      );
      return super._pushOperation(
        "BurgissCalcValuationMinDate",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Minandmaxdate
      );
    }
    if (idType == "i") {
      const objRequest = this.createPayload(
        investId,
        idType,
        beginDate,
        endDate,
        selectionSetId,
        filter,
        MeasuresType.ValuationMinDate,
        [],
        []
      );
      return super._pushOperation(
        "BurgissCalcValuationMinDate",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Minandmaxdate
      );
    }
    if (idType == "a") {
      const objRequest = this.createPayload(
        [],
        idType,
        beginDate,
        endDate,
        selectionSetId,
        filter,
        MeasuresType.ValuationMinDate,
        [],
        investId
      );
      return super._pushOperation(
        "BurgissCalcValuationMinDate",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Minandmaxdate
      );
    }
    return null;
  }
  burgissCalcStockMinDate(
    investId: any[][],
    idType: any,
    beginDate: any,
    endDate?: any,
    selectionSetId?: any,
    filter?: any
  ) {
    if (idType == "p") {
      const objRequest = this.createPayload(
        [],
        idType,
        beginDate,
        endDate,
        selectionSetId,
        filter,
        MeasuresType.StockMinDate,
        investId,
        []
      );
      return super._pushOperation(
        "BurgissCalcStockMinDate",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Minandmaxdate
      );
    }
    if (idType == "i") {
      const objRequest = this.createPayload(
        investId,
        idType,
        beginDate,
        endDate,
        selectionSetId,
        filter,
        MeasuresType.StockMinDate,
        [],
        []
      );
      return super._pushOperation(
        "BurgissCalcStockMinDate",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Minandmaxdate
      );
    }
    if (idType == "a") {
      const objRequest = this.createPayload(
        [],
        idType,
        beginDate,
        endDate,
        selectionSetId,
        filter,
        MeasuresType.StockMinDate,
        [],
        investId
      );
      return super._pushOperation(
        "BurgissCalcStockMinDate",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Minandmaxdate
      );
    }
    return null;
  }
  burgissCalcStockMaxDate(
    investId: any[][],
    idType: any,
    beginDate: any,
    endDate?: any,
    selectionSetId?: any,
    filter?: any
  ) {
    if (idType == "p") {
      const objRequest = this.createPayload(
        [],
        idType,
        beginDate,
        endDate,
        selectionSetId,
        filter,
        MeasuresType.StockMaxDate,
        investId,
        []
      );
      return super._pushOperation(
        "BurgissCalcStockMaxDate",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Minandmaxdate
      );
    }
    if (idType == "i") {
      const objRequest = this.createPayload(
        investId,
        idType,
        beginDate,
        endDate,
        selectionSetId,
        filter,
        MeasuresType.StockMaxDate,
        [],
        []
      );
      return super._pushOperation(
        "BurgissCalcStockMaxDate",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Minandmaxdate
      );
    }
    if (idType == "a") {
      const objRequest = this.createPayload(
        [],
        idType,
        beginDate,
        endDate,
        selectionSetId,
        filter,
        MeasuresType.StockMaxDate,
        [],
        investId
      );
      return super._pushOperation(
        "BurgissCalcStockMaxDate",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Minandmaxdate
      );
    }
    return null;
  }
  createPayload(
    investId: any[][] = null,
    idType: string = null,
    beginDate: any = null,
    endDate: any = null,
    selectionSetId: any = null,
    filter: any = "",
    measure: string = null,
    portfolioId: any[][] = null,
    assetId: any[][] = null
  ) {
    const minAndMaxDateObject: Measures = {
      excludeBalanceSheetItems: false,
      excludeUndisclosedItems: false,
      excludeUnknownEntities: false,
      excludeRealizationsPriorToClosingDate: null,
      financeIndexID: null,
      financePremium: null,
      reinvestmentIndexID: null,
      reinvestmentPremium: null,
      forceRollForward: null,
      peergroupID: null,
      percentile: null,
      currency: null,
      returnConstituentCount: false,
      investmentID: String(investId).toUpperCase() == "ALL" ? "-1" : String(investId),
      portfolioID: String(portfolioId).toUpperCase() == "ALL" ? "-1" : String(portfolioId),
      isHoldingCalc: false,
      returnPooledResult: true,
      baseCurrency: true,
      alternateBaseCurrency: null,
      adjustToMostRecent: false,
      measure: measure,
      beginDate: beginDate,
      endDate: endDate,
      year: null,
      indexID: null,
      premium: null,
      idType: idType,
      selectionsetID: selectionSetId,
      assetID: String(assetId).toUpperCase() == "ALL" ? "-1" : String(assetId),
      weightingMethod: null,
      value: null,
      filter: filter,
      attributeName: null,
      rankValue: null,
      bMUHistoricalWindowLengthQtrs: 0,
      maxAgeDiffYears: null,
      horizon: null,
      maxDroppedPeriods: null,
      lastHistoricalEOQDate: null,
      numSimulations: null,
      desiredSampleSize: null,
      minSampleSize: null,
      sampleStatistic: null,
      stopOn: null,
      requireReportedValuation: 0,
      alias: null,
      currencyHedgesetId: null,
      foFLookThrough: false,
      useReceivedDate: false,
      excludeFrozenAsset: true,
      useAlternateFundSize: false,
      dynamicParameter: null,
      universe: null,
      weight: null,
      commitment: null,
    };
    return minAndMaxDateObject;
  }
}
